import React from "react";
import proptypes from "prop-types";
import { Typography } from "@one-thd/sui-atomic-components";
import { TooltipContent } from "./tooltip-content";

const { bool, shape, string } = proptypes;

export const AvailabilityTooltipContent = ({
  showMainTooltip,
  showUnavailableTooltip,
  hoveredCombinationDetails,
  unavailableTooltipMessage,
}) => {
  if (showMainTooltip) {
    return <TooltipContent hoveredCombinationDetails={hoveredCombinationDetails} />;
  }
  if (showUnavailableTooltip) {
    return (
      <Typography variant="body-base" align="center">
        {unavailableTooltipMessage}
      </Typography>
    );
  }
  return null;
};

AvailabilityTooltipContent.propTypes = {
  showMainTooltip: bool,
  showUnavailableTooltip: bool,
  hoveredCombinationDetails: shape({}),
  unavailableTooltipMessage: string,
};

AvailabilityTooltipContent.defaultProps = {
  showMainTooltip: false,
  showUnavailableTooltip: false,
  hoveredCombinationDetails: {},
  unavailableTooltipMessage: "",
};
